<template>
    <v-container fluid class="my-0 px-0  py-0">
        <div class="text-center pt-10 pr-12">
            <v-btn @click="getDocument">Reload</v-btn>
        </div>
        <v-dialog class="test-center" v-model="loading" width="200">
            <div class="text-center white pa-10">
                Loading Document... <v-progress-circular indeterminate size="30"></v-progress-circular>
            </div>
        </v-dialog>
        <v-dialog v-model="showPreview" width="95%" max-width="900px" :fullscreen="$vuetify.breakpoint.xs">
            <v-card v-if="previewDocumentDocType === 'pdf'" style="position:relative">
                <v-btn @click="downloadDoc" fab left absolute color="primary">
                    <v-icon>fas fa-download</v-icon>
                </v-btn>
                <v-btn @click="closePreview" fab color="red" right absolute>
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <PdfPreview :value="previewDocumentUrl" />
            </v-card>
            <v-card v-else-if="previewDocumentDocType === 'image'" style="position:relative">
                <v-btn @click="downloadDoc" fab left absolute color="primary">
                    <v-icon>fas fa-download</v-icon>
                </v-btn>
                <v-btn @click="closePreview" fab color="red" right absolute>
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <v-img :src="previewDocumentUrl"></v-img>
            </v-card>
            <v-card v-else-if="previewDocumentDocType === 'download'" class="pa-10" style="position:relative">
                <v-btn @click="closePreview" fab color="red" right absolute>
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <div class="text-center">
                    <strong>No Preview Available</strong><br>
                    <v-btn @click="downloadDoc" color="primary">
                        Download <v-icon right>fas fa-download</v-icon>
                    </v-btn>
                </div>
            </v-card>
            <v-card v-else style="position:relative;overflow:hidden;">
                <v-btn @click="closePreview" fab color="red" right absolute>
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <DocumentPreview :url="previewDocumentUrl" :type="previewDocumentDocType" />
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import PdfPreview from '@/CMS/editor/components/PdfPreview.vue'
import DocumentPreview from "@/CMS/views/DocumentPreview/DocumentPreview.vue";

const previewTypeMap = {
    office: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
    image: ['jpg', 'png', 'gif'],
    pdf: ['pdf'],
    code: ['csv'],
    text: ['text'],
}

export default {
    data() {
        return {
            loading: false,
            showPreview: false,
            previewDocumentDocType: null,
            previewDocumentUrl: null,
            currentDoc: null,
        }
    },
    mounted: function() {
        this.getDocument()
    },
    methods: {
        getDocument () {
            const id = this.$route.params.document_id
            this.loading = true
            QuilityAPI.getDocument(id)
                .then((json) => {
                    this.loading = false
                    this.currentDoc = json.data
                    this.previewDocument(this.currentDoc)
                })
                .catch(() => { this.loading = false })
        },
        previewDocument (doc) {
            this.previewDocumentDocType = this.getPreviewType(doc.DocType)
            this.previewDocumentUrl = this.getDocLink(doc.ViewLink, doc.DocType)
            this.showPreview = true
        },
        downloadDoc () {
            const url = this.getDocLink(this.currentDoc?.DownloadLink, this.currentDoc?.DocType)
            window.open(url, '_blank')
        },
        getPreviewType (doctype) {
			const type = doctype.toLowerCase?.() || doctype
			const previewTypeName = Object.entries(previewTypeMap).find(([name , types]) => types.includes(type))
			return previewTypeName?.[0] || 'download'
        },
		getDocLink (link, doctype) {
            if (link.startsWith('http://localhost:8000')) {
                return link.replace('http://localhost:8000', process.env.VUE_APP_BASE_URL)
            }
			if (process.env.NODE_ENV === 'development') { // to avoid CORS errors in dev
                const previewDocumentDocType = this.getPreviewType(doctype)
                if (previewDocumentDocType !== 'office') {
                    return link.replace(new URL(link).origin, '')
                }
			}
			return link
		},
        closePreview () {
            this.previewDocumentUrl = ''
            this.showPreview = false
        },
    },
    watch: {
        showPreview (val) {
            if (!val) { this.previewDocumentUrl = '' }
        },
    },
    components: {
        DocumentPreview,
        PdfPreview,
    }
}
</script>
